/* eslint-disable import/prefer-default-export */
/* eslint-disable arrow-body-style */
import { useQuery, useMutation } from "@tanstack/react-query";
import DisputesService from "@services/DisputesService";
import QueryClient from "@services/QueryClient";

const NonRKPayInvoiceKeys = {
	all: ["app"],
	disputes: {
		byId: (disputeId) => [...NonRKPayInvoiceKeys.all, "disputes", disputeId],
		history: (invoiceId) => [...NonRKPayInvoiceKeys.all, "disputes", "history", invoiceId],
	}
}

/* HELPERS */
export const invalidateDisputeById = (disputeId) => {
	return QueryClient.invalidateQueries({
		queryKey: NonRKPayInvoiceKeys.disputes.byId(disputeId),
	});
}

export const getDisputeQueryData = (disputeId) => {
	return QueryClient.getQueryData(NonRKPayInvoiceKeys.disputes.byId(disputeId));
}

export const setDisputeQueryData = (disputeId, data) => {
	return QueryClient.setQueryData(NonRKPayInvoiceKeys.disputes.byId(disputeId), data);
}

/* QUERIES */
export const useGetDisputeById = (disputeId, options = {}) => {
	return useQuery({
		queryFn: () => DisputesService.getDisputeById(disputeId),
		queryKey: NonRKPayInvoiceKeys.disputes.byId(disputeId),
		enabled: !!disputeId,
		...options,
	});
}

export const useGetDisputeHistory = (invoiceId, options = {}) => {
	return useQuery({
		queryKey: NonRKPayInvoiceKeys.disputes.history(invoiceId),
		queryFn: () => DisputesService.getDisputeHistory(invoiceId),
		enabled: !!invoiceId,
		...options,
	});
}


/* MUTATIONS */

export const useUpdateDisputeReason = () => {
	return useMutation({
		mutationFn: async ({ disputeId, disputeReasonId, data }) => {
			const response = await DisputesService.updateDisputeReason(disputeReasonId, data)
			const dispute = getDisputeQueryData(disputeId);
			const updatedDispute = Object.keys(dispute).reduce((acc, key) => {
				acc[key] = dispute[key].map(reason => {
					if (reason.Id === disputeReasonId) {
						return { ...reason, ...data };
					}
					return reason;
				});
				return acc;
			}, {});
			setDisputeQueryData(disputeId, updatedDispute);
			return response;
		},
	});
}
